import { useLocation } from 'react-router-dom';
import { Check } from '@/components/icons';
import { ALL_ITEMS } from '@/layout/modules';

/**
 * Phase 0 placeholder — each of the 41 modules points to this until its real
 * page is implemented in Phase 1+. The breadcrumb shows the module id from
 * docs/modules.md so reviewers can confirm routing wiring without leaving the app.
 */
export function PlaceholderPage() {
  const loc = useLocation();
  const item = ALL_ITEMS.find((i) => i.path === loc.pathname);

  return (
    <div className="space-y-6">
      <div>
        <div className="text-2xl font-black text-[var(--text-primary)]">{item?.label ?? 'Page'}</div>
        <div className="mt-1 text-xs text-[var(--text-muted)]">
          Module id: <code className="text-accent">{item?.moduleId ?? '—'}</code> · Path:{' '}
          <code className="text-accent">{loc.pathname}</code>
        </div>
      </div>

      <div className="rounded-card border border-[var(--border-color)] bg-[var(--card-bg)] p-6 backdrop-blur-xl">
        <div className="text-sm font-bold text-accent">Phase 0 — route is wired <Check size={13} className="inline-block align-[-2px]" /></div>
        <p className="mt-2 text-sm text-[var(--text-secondary)]">
          Implementation for this module ships in a later phase. See{' '}
          <code className="text-accent">docs/modules.md</code> for the spec:
          fields, table columns, actions, and workflow connections.
        </p>
      </div>
    </div>
  );
}
